var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:{
    'notification--unread': _vm.readedAt === null,
    'notification--success': _vm.success,
    'notification--error': _vm.error,
    'notification--warning': _vm.warning,
  }},[_c('div',{staticClass:"notification-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }